module.exports = __webpack_public_path__ + "img/201611-1-1024x768.77214991.jpg";